var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8947 0C5.74274 2.29395 7.57487 9.68421 5.22039 9.68421C3.45424 9.68421 2.78752 6.68627 2.78752 6.68627C2.78752 6.68627 0 11.2998 0 15.6565C0 22.0795 7.26316 22.9929 7.26316 22.9929C6.74505 22.2702 3.39068 20.355 6.05263 15.7368C7.35879 20.6964 11.5605 19.2486 9.68421 12.1053C11.6973 13.7516 12.1053 16.1133 12.1053 18.1579C12.1053 20.7884 10.074 22.3052 9.68421 23C13.2528 22.4649 15.7368 19.2026 15.7368 16.4911C15.7368 12.0545 10.8947 4.14726 10.8947 0Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurn);
export default __webpack_public_path__ + "static/media/Burn.df5e23bc17dc2d485cfe51c534274bfa.svg";
export { ForwardRef as ReactComponent };